// extracted by mini-css-extract-plugin
export default {"App":"App_App__Xw9hg","switch-wrapper":"App_switch-wrapper__Ocm4d"};